export default __webpack_public_path__ + "static/HelveticaNeueLTStd-MdCn-daef94b50fbfd10450f9b87b742fd99b.eot";